/**
 * Copy única dos fluxos de selfie (Identy e FaceTec).
 *
 * Contrato da proposta de UX BB:
 *   - uma instrução por vez (alerta OU toast, nunca os dois para o mesmo evento);
 *   - nenhum jargão técnico ou "erro interno" exposto ao usuário;
 *   - o botão de retentativa é sempre "Tentar novamente".
 */
export const SELFIE_MESSAGES = {
  // Telas de espera
  loadingEnvironment: 'Aguarde enquanto preparamos o ambiente.',
  loadingCamera: 'Aguarde enquanto iniciamos a câmera.',
  processing: 'Validando...',

  // Não há mensagem de conclusão aqui de propósito: o portal é isento quanto
  // ao resultado da biometria e a tela de conclusão já exibe o texto do
  // cliente (text-completed-title / text-completed-description).

  // Títulos
  retryTitle: 'Não foi possível validar',
  terminalTitle: 'Não foi possível validar',

  // Mensagens
  retry: 'Não foi possível concluir. Tente novamente.',
  environmentFailure: 'Não foi possível preparar o ambiente da câmera. Por favor, tente novamente.',
  startFailure: 'Não foi possível iniciar a validação da sua selfie. Tente novamente.',
  validationFailure: 'Não foi possível validar sua selfie. Tente novamente.',
  attemptsExceeded: 'Não foi possível validar sua selfie e o limite de tentativas foi atingido. Reinicie o processo para tentar novamente.',
  invalidStep: 'Não conseguimos validar o seu passo atual, por favor, reinicie o processo!',
  genericFailure: 'Não foi possível validar sua solicitação.',

  // Ações
  buttonRetry: 'Tentar novamente',
  buttonRestart: 'Reiniciar o processo'
}
